import { JourneyStage } from 'types';

interface StepDisabledStyle {
  background: string;
}

interface StepActiveStyle {
  activeClassName: string;
  iconBgClassName: string;
  stepActiveClassName: string;
}

interface StepData extends StepDisabledStyle, StepActiveStyle {}

type StepColor = (typeof StepColors)[keyof typeof StepColors];

const StepColors = {
  Green: '#80B344',
} as const;

const disabledStyles: Record<StepColor, StepDisabledStyle> = {
  [StepColors.Green]: {
    background: 'linear-gradient(154deg, #F4FFD9 -12.3%, #F9FFEA 87.56%)',
  },
};

const activeStyles: Record<StepColor, StepActiveStyle> = {
  [StepColors.Green]: {
    iconBgClassName: 'bg-greenlight-primary',
    activeClassName: 'bg-accent-gradient-primary-primary',
    stepActiveClassName: 'bg-accent-gradient-primary-primary',
  },
};

export const getStepData = (color: string): StepData => {
  const disabled = disabledStyles[color as StepColor] || {
    background: 'linear-gradient(154deg, #F4FFD9 -12.3%, #F9FFEA 87.56%)',
  };
  const active = activeStyles[color as StepColor] || {
    iconBgClassName: 'bg-greenlight-primary',
    activeClassName: 'bg-accent-gradient-primary-primary',
    stepActiveClassName: 'bg-accent-gradient-primary-primary',
  };
  return {
    ...active,
    ...disabled,
  };
};

export type FormStepStages =
  | JourneyStage.PRE_TRAINING
  | JourneyStage.POST_TRAINING;

export const FormStepDuration: Record<FormStepStages, string> = {
  [JourneyStage.PRE_TRAINING]: '1 min',
  [JourneyStage.POST_TRAINING]: '1 min',
};
